import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

class AgentCodeService extends BaseCollectionService {
  constructor() {
    super("agent-codes");
  }

  async getAgentCodes(
    query: Record<string, any> = {}
  ): Promise<ResponseWrapper> {
    return await this.request(
      {
        method: "get",
        url: this.url,
        params: query
      },
      { useToken: "access" }
    );
  }
}

export default new AgentCodeService();
